// src/pages/Story.js - VERSI&iacute;“N FINAL LIMPIA
import React, { useState, useEffect, useRef } from 'react'; // â† Agrega useRef
import { useParams, useNavigate } from 'react-router-dom';
import { getStory, continueStory, customAction, regenerateSegment,  regenerateImage,  getImageStyles,  regenerateImageWithStyle    } from '../services/api';


function Story() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentSegment, setCurrentSegment] = useState(null);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customActionText, setCustomActionText] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFeedback, setEditFeedback] = useState('');
  const isProcessing = useRef(false);
  const [regeneratingImage, setRegeneratingImage] = useState(false);
  const [currentRoundIndex, setCurrentRoundIndex] = useState(0);
  const [totalRounds, setTotalRounds] = useState(0);
  const [estilos, setEstilos] = useState([]);
  const [estiloSeleccionado, setEstiloSeleccionado] = useState('fantas&iacute;a &eacute;©pica');
  const [showStyleSelector, setShowStyleSelector] = useState(false);
	
 useEffect(() => {
	 fetchStory();
	 loadImageStyles();
 }, [id]);
	
	 const loadImageStyles = async () => {
		  try {
			const response = await getImageStyles();
			setEstilos(response.data.estilos);
		  } catch (error) {
			console.error('Error cargando estilos:', error);
		  }
		};

	  const fetchStory = async () => {
		setLoading(true);
		try {
		  console.log('ID recibido:', id);  // Debe mostrar un n&iacute;ºmero
		  const data = await getStory(id);  // â† id debe ser el valor
	      console.log('Datos completos:', data.data);  // â† AGREGAR ESTO
		  setStory(data.data);
		  if (data.data.segmentos && data.data.segmentos.length > 0) {
			 const total = data.data.segmentos.length;
			 setTotalRounds(total);
      		 setCurrentRoundIndex(total - 1); // &iacute;šltima ronda
			 const esteSegement = data.data.segmentos[total - 1];
			 console.log(' Segmento actual:', esteSegement); // â† AGREGAR ESTO
      		 setCurrentSegment(esteSegement);
			  
			 //const lastSegment = data.data.segmentos[data.data.segmentos.length - 1];
			 //setCurrentSegment(lastSegment);
		  }
		} catch (error) {
		  console.error('Error:', error);
		} finally {
		  setLoading(false);
		}
	  };
	
	const goToPreviousRound = () => {
	  if (currentRoundIndex > 0) {
		const newIndex = currentRoundIndex - 1;
		const segmento = story.segmentos[newIndex];
		console.log('📦 Segmento recuperado:', segmento); // ← AGREGAR
		setCurrentRoundIndex(newIndex);
		setCurrentSegment({
		  ...story.segmentos[newIndex],
		  opciones: story.segmentos[newIndex].opciones || []
		});
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	const goToNextRound = () => {
	  if (currentRoundIndex < totalRounds - 1) {
		const newIndex = currentRoundIndex + 1;
		setCurrentRoundIndex(newIndex);
		setCurrentSegment({
		  ...story.segmentos[newIndex],
		  opciones: story.segmentos[newIndex].opciones || []
		});
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	const goToFirstRound = () => {
	  if (currentRoundIndex > 0) {
		setCurrentRoundIndex(0);
		setCurrentSegment({
		  ...story.segmentos[0],
		  opciones: story.segmentos[0].opciones || []
		});
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	const goToLastRound = () => {
	  if (currentRoundIndex < totalRounds - 1) {
		const lastIndex = totalRounds - 1;
		setCurrentRoundIndex(lastIndex);
		setCurrentSegment({
		  ...story.segmentos[lastIndex],
		  opciones: story.segmentos[lastIndex].opciones || []
		});
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	const handleRegenerateImageWithStyle = async () => {
	  setRegeneratingImage(true);
	  try {
		const response = await regenerateImageWithStyle(currentSegment.id, estiloSeleccionado);

		setCurrentSegment(prev => ({
		  ...prev,
		  imagen_url: response.data.imagen
		}));

		setShowStyleSelector(false);
	  } catch (error) {
		console.error('Error regenerando imagen:', error);
		alert('No se pudo generar la imagen con ese estilo. Probablemente los filtros de contenido lo bloquearon. Intenta con otro estilo.');
	  } finally {
		setRegeneratingImage(false);
	  }
	};
	
	
	const handleOption = async (opcionId) => {
	  if (isProcessing.current) return; // â† Si ya est&iacute;¡ procesando, no hace nada

	  isProcessing.current = true;
	  setLoading(true);

	  try {
		const result = await continueStory(id, opcionId);
		  
		const newSegment = result.data.segmento;
    	const newOptions = result.data.opciones;

		setStory(prev => ({
		  ...prev,
		  segmentos: [...(prev?.segmentos || []), newSegment]
		}));

		setCurrentSegment({
		  ...newSegment,
		  opciones: newOptions
		});

		// Actualizar &iacute;­ndices
		setTotalRounds(prev => prev + 1);
		setCurrentRoundIndex(prev => prev + 1);
					  
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  } catch (error) {
		console.error('Error:', error);
		alert('Error al continuar la historia');
	  } finally {
		setLoading(false);
		isProcessing.current = false; // â† Liberar el flag
	  }
	};
					
					
  const handleCustomAction = async () => {
	  if (isProcessing.current) return; // â† Si ya est&iacute;¡ procesando, no hace nada

					  
	  if (!customActionText.trim()) {
		alert('Escribe una acci&oacute;n');
		return;
	  }
	  isProcessing.current = true; // aciiva proteccion

	  setLoading(true);
	  try {
		const result = await customAction(id, customActionText);
					  
		const newSegment = result.data.segmento;
    	const newOptions = result.data.opciones;

		setStory(prev => ({
		  ...prev,
		  segmentos: [...(prev?.segmentos || []), newSegment]
		}));

		setCurrentSegment({
		  ...newSegment,
		  opciones: newOptions
		});

		setShowCustomInput(false);
		setCustomActionText('');

		// Actualizar Indices
		setTotalRounds(prev => prev + 1);
		setCurrentRoundIndex(prev => prev + 1);
					  
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  } catch (error) {
		console.error('Error:', error);
		alert('Error al procesar tu acci&oacute;n');
	  } finally {
		setLoading(false);
		isProcessing.current = false; // Liberar el flag
	  }
	};
	
	
	const handleRegenerate = async () => {
	  if (isProcessing.current) return; // Si ya est&iacute;¡ procesando, no hace nada


	  if (!editFeedback.trim()) {
		alert('Escribe qu&iacute; cambios quieres hacer');
		return;
	  }

	  isProcessing.current = true; // aciiva proteccion
	  setLoading(true);
	  try {
		const result = await regenerateSegment(id, editFeedback);

		const newSegment = result.data.segmento;
    	const newOptions = result.data.opciones;

		// Actualizar el segmento actual con el nuevo texto
		setCurrentSegment({
		  ...newSegment,
		  opciones: newOptions
		});

		// Actualizar tambi&iacute;©n en el array de segmentos
		setStory(prev => ({
		  ...prev,
		  segmentos: prev.segmentos.map(seg => 
			seg.id === newSegment ? newSegment : seg
		  )
		}));

		setShowEditModal(false);
		setEditFeedback('');

		// Actualizar &iacute;­ndices
		setTotalRounds(prev => prev + 1);
		setCurrentRoundIndex(prev => prev + 1);
					  
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  } catch (error) {
		console.error('Error:', error);
		alert('Error al regenerar el texto');
	  } finally {
		setLoading(false);
		isProcessing.current = false; //  Liberar el flag
	  }
	};
	
	const handleRegenerateImage = async (segmentoId) => {
		  setRegeneratingImage(true);
		  try {
			const response = await regenerateImage(segmentoId);

			// Actualizar la imagen del segmento actual
			setCurrentSegment(prev => ({
			  ...prev,
			  imagen_url: response.data.imagen  //  CAMBIA 'imagen' por 'imagen_url'
			}));

			// Actualizar tambi&iacute;©n en el array de segmentos
			setStory(prev => ({
			  ...prev,
			  segmentos: prev.segmentos.map(seg => 
				seg.id === segmentoId ? { ...seg, imagen: response.data.imagen } : seg
			  )
			}));

		  } catch (error) {
			console.error('Error regenerando imagen:', error);
			alert('Error al regenerar la imagen');
		  } finally {
			setRegeneratingImage(false);
		  }
		};


  if (loading && !currentSegment) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <h2>Cargando tu universo...</h2>
      </div>
    );
  }

  return (
    <div className="story-container">
      <div className="story-header">
        <button 
          className="btn btn-back"
          onClick={() => navigate('/dashboard')}
        >
          🌌 Mis universos
        </button>
        
        <div className="story-info">
          <h1 className="story-title">{story?.sesion?.titulo || 'Aventura en el multiverso'}</h1>
          <span className="story-genre">{story?.sesion?.genero}</span>
        </div>
      </div>

      {currentSegment && (
        <div className="story-card">
          <div className="story-segment">
            <div className="segment-badge">
               {currentRoundIndex + 1} / {totalRounds}
            </div>
            
            {/* UNICA VERSION DEL TEXTO - CON DISEÑO PROFESIONAL */}
            <div className="story-text">
              {currentSegment.texto_generado || currentSegment.texto}
            </div>

				{/* Secci&oacute;n de imagen - visible siempre */}
				<div className="story-image-section">
				  {currentSegment?.imagen_url ? (
					<div className="story-image-container"  title="🧪 Beta: Las imágenes son ilustrativas">
					  <img 
						src={currentSegment.imagen_url} 
						alt="Escena de la historia"
						className="story-image"
					  />
					</div>
				  ) : (
					<div className="story-image-placeholder">
					  <span>🎨  Este segmento no tiene imagen</span>
					</div>
				  )}

				  <div className="story-image-actions">
					{!showStyleSelector ? (
					  <>
						<button 
						  className="btn-regenerate-image"
						  onClick={() => handleRegenerateImage(currentSegment.id)}
						  disabled={regeneratingImage}
						>
						  {regeneratingImage ? '🔄  Generando...' : '🎨  Regenerar imagen'}
						</button>
						<button 
						  className="btn-select-style"
						  onClick={() => setShowStyleSelector(true)}
						>
						  🎭 Cambiar estilo
						</button>
					  </>
					) : (
					  <div className="style-selector">
						<h4>Elige un estilo para la imagen:</h4>
						<div className="styles-grid">
						  {estilos.map(estilo => (
							<div 
							  key={estilo.id}
							  className={`style-option ${estiloSeleccionado === estilo.id ? 'selected' : ''}`}
							  onClick={() => setEstiloSeleccionado(estilo.id)}
							>
							  <span className="style-name">{estilo.nombre}</span>
							  <span className="style-desc">{estilo.descripcion}</span>
							</div>
						  ))}
						</div>
						<div className="style-actions">
						  <button 
							className="btn-apply-style"
							onClick={handleRegenerateImageWithStyle}
							disabled={regeneratingImage}
						  >
							{regeneratingImage ? 'Generando...' : 'Aplicar estilo y regenerar'}
						  </button>
						  <button 
							className="btn-cancel-style"
							onClick={() => setShowStyleSelector(false)}
						  >
							Cancelar
						  </button>
						</div>
					  </div>
					)}
				  </div>
				</div>


				{/* Bot&oacute;n de edici&oacute;n */}
				<div className="edit-section">
				  <button 
					className="btn-edit-story"
					onClick={() => setShowEditModal(true)}
					disabled={loading}
				  >
					✏️ No me gusta este texto, quiero cambiarlo
				  </button>
				</div>


				{/* Modal de edici&oacute;n */}
				{showEditModal && (
				  <div className="edit-modal">
					<div className="edit-modal-content">
					  <h3>Â¿Qu&iacute;© quieres cambiar?</h3>
					  <p className="edit-modal-subtitle">
						Describe qu&iacute; aspectos del texto no te gustan o c&oacute;mo deber&iacute;a ser:
					  </p>

					  <textarea
						value={editFeedback}
						onChange={(e) => setEditFeedback(e.target.value)}
						placeholder="Ej: El personaje del mago no me gusta, prefiero que sea una elfa. Tambi&eacute;n quiero que la escena sea m&aacute;s misteriosa y menos violenta..."
						rows="5"
						disabled={loading}
					  />

					  <div className="edit-modal-buttons">
						<button 
						  onClick={handleRegenerate}
						  disabled={loading}
						  className="btn-regenerate"
						>
						  {loading ? 'Regenerando...' : '✨ Regenerar texto'}
						</button>
						<button 
						  onClick={() => setShowEditModal(false)}
						  className="btn-cancel"
						>
						  Cancelar
						</button>
					  </div>
					</div>
				  </div>
				)}
				
				{/* Barra de navegaci&iacute;n de rondas */}
			{totalRounds > 1 && (
			  <div className="rounds-navigation">
				<div className="rounds-info">
				  <span>Ronda {currentRoundIndex + 1} de {totalRounds}</span>
				</div>
				<div className="rounds-buttons">
				  <button 
					onClick={goToFirstRound}
					disabled={currentRoundIndex === 0}
					className="nav-round-btn"
					title="Ir al inicio"
				  >
					⏮️
				  </button>
				  <button 
					onClick={goToPreviousRound}
					disabled={currentRoundIndex === 0}
					className="nav-round-btn"
					title="Ronda anterior"
				  >
					◀️
				  </button>
				  <span className="rounds-progress">
					{currentRoundIndex + 1} / {totalRounds}
				  </span>
				  <button 
					onClick={goToNextRound}
					disabled={currentRoundIndex === totalRounds - 1}
					className="nav-round-btn"
					title="Ronda siguiente"
				  >
					▶️
				  </button>
				  <button 
					onClick={goToLastRound}
					disabled={currentRoundIndex === totalRounds - 1}
					className="nav-round-btn"
					title="Ir al final"
				  >
					⏭️
				  </button>
				</div>
			  </div>
			)}

            {currentSegment.opciones && currentSegment.opciones.length > 0 && (

				<div className="options-section">
				  <h3 className="options-title">¿Qué camino eliges?</h3>
				  <div className="options-grid">
					{/* Opciones de la IA */}
					{currentSegment.opciones.map((opcion, index) => (
					  <button
						key={opcion.id}
						className="option-btn"
						onClick={() => handleOption(opcion.id)}
						disabled={loading}
					  >
						<span className="option-number">Opción {index + 1}</span>
						<span className="option-text">{opcion.texto}</span>
					  </button>
					))}

					{/* 4ta OPCIÓN PERSONALIZADA */}
					<div className="custom-option-container">
					  {!showCustomInput ? (
						<button 
						  className="option-btn custom-option-btn"
						  onClick={() => setShowCustomInput(true)}
						  disabled={loading}
						>
						  <span className="option-number">⚡</span>
						  <span className="option-text">Acción personalizada</span>
						  <span className="custom-badge">¡Tú decides!</span>
						</button>
					  ) : (
						<div className="custom-input-area">
						  <textarea
							value={customActionText}
							onChange={(e) => setCustomActionText(e.target.value)}
							placeholder="Escribe lo que quieres hacer..."
							rows="3"
							autoFocus
							disabled={loading}
						  />
						  <div className="custom-buttons">
							<button 
							  onClick={handleCustomAction}
							  disabled={loading || !customActionText.trim()}
							  className="btn-custom-submit"
							>
							  {loading ? 'Procesando...' : '⚡ Realizar acción'}
							</button>
							<button 
							  onClick={() => setShowCustomInput(false)}
							  className="btn-custom-cancel"
							>
							  Cancelar
							</button>
						  </div>
						</div>
					  )}
					</div>
				  </div>
				</div>
            )}
          </div>
        </div>
      )}

      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner small"></div>
          <p>Expandiendo el universo...</p>
        </div>
      )}
    </div>
  );
					
}

export default Story;